const PromoMobileProductsSort = ({ value, onChange }) => (
  <select
    value={value}
    onChange={(event) => onChange(event.target.value)}
    className="max-w-full py-2 px-5 border rounded-bl-lg rounded-tr-lg bg-white border-primary w-full h-[50px]"
  >
    <option value="default">Sortare implicita</option>
    <option value="price">Cel mai mic pret</option>
    <option value="discount">Cea mai mare reducere</option>
  </select>
);

export default PromoMobileProductsSort;
